import LayoutMain from './../../../layouts/LayoutMain.vue';
import ProgressHUD from './../../ProgressHUD/index.vue'
import Footer from './../../Footers/Footer/index.vue'
import VueCropper from 'vue-cropper'
import { Api, Toast, Helper } from './../../../services'

export default {
  name: 'SettingsProfile',
  props: [],
  components: {
    LayoutMain,
    ProgressHUD,
    VueCropper,
    Footer,
  },
  data() {
    return {
      userData: {},
      validationMessage: '',
      validationMessage2: '',
      newAvatarImmage: null,
      countries: "",
      isGreen: false,
      isEmail: false,
      isCode: false,
      passwordCheck: '',
      typeOfProfile: [],
      producer: false,
      affiliate: false,
      investor: false,
      titles: {0:"Prof.",1:"Dr.",2:"Mr.",3:"Mrs.",4:"Ms.",5:"Miss",6:"Mx.",7:"Sir",8:"Lady",9:"Lord"},
      othertitle: "",
      passwordOld: "",
      password: '',
      passwordNew: '',
      isGreen20: false,
      isOne: true,
    }
  },
  computed: {

  },
  methods: {
    changeFile() {
      $('#profile-img').click();
    },
    getIMG(event) {
      var files = ""
      if (event.target) files = event.target.files || event.dataTransfer.files
      if (files && files[0]) {
        this.newAvatarImmage = files[0]

        // Auto refresh Avatar on page
        var self = this
        var reader = new FileReader()
        reader.onload = e => (self.userData.image = e.target.result)
        reader.readAsDataURL(files[0])
      }
    },
    editGreen() {
      //this.isGreen=true;
      this.validationMessage = ''
      $('.modal.modal1').modal('show')
      this.isOne = true
    },
    editGreen20() {
      //this.isGreen=true;
      this.validationMessage = ''
      $('.modal.modal1').modal('show')
      this.isOne = false
    },
    changeStatus(){
      if(this.affiliate == true || this.investor == true) {

       if (this.userData.fullName === '' || this.userData.country === '' || this.userData.country === undefined || this.userData.address === '' || this.userData.idPassportForKYC == undefined || this.userData.idPassportForKYC.length <= 0) {

          var c = '', addr = '', p = '', b = ''
          c = this.userData.country ? this.userData.country : ''
          addr = this.userData.address ? this.userData.address : ''
          p = this.userData.idPassportForKYC ? this.userData.idPassportForKYC[0] : ''
          b = this.userData.utilityBill ? this.userData.utilityBill : ''

          this.$localStorage.set('address', addr)
          this.$localStorage.set('country', c)
          this.$localStorage.set('idPassportForKYC', p)
          this.$localStorage.set('utilityBill', b)

          this.$router.push('/kyc')

        }   
      }  
    },
    async openEdit() {
      try {
        if (this.passwordCheck=='') {
            Toast.validationFieldsError({ toast: this.$toast })
            this.validationMessage = 'The field is required'
            return
          }
        var data = {
          email: this.userData.email,
          password: this.passwordCheck,
        }
        console.log(data)
        this.validationMessage = ''
        
        var response = await Api.signIn(this.userData.email, this.passwordCheck)
               
        if (this.isOne == true)
          this.isGreen = true;
        else 
          this.isGreen20 = true;
        $('.modal.modal1').modal('hide')

      } catch (error) {
        console.error(error)
        this.validationMessage = error.message        

        Toast.error({
          toast: this.$toast,
          title: 'Password is wrong',
          message: error.message,
        })
      } finally {false,
        this.$refs.progress.hide()
      } 

    },
    async saveGreenWallet() {
      try {
        const isValid = await this.$validator.validate()
        if (!isValid) {
          Toast.validationFieldsError({ toast: this.$toast })

          return
        }

        this.$refs.progress.show()

        var walletAddress = (this.isOne == true) ? this.userData.walletAddressGREEN : this.userData.walletGREENBEP20
        var data = { walletAddressGREEN: walletAddress, isOne: this.isOne} 

        var response = await Api.updateGreenWallet(data)

        if (this.isOne == true) this.isGreen = false; else this.isGreen20 = false;

        Toast.success({
          toast: this.$toast,
          title: 'Success saving!',
          message: 'Successfully',
        })

      } catch (error) {
        console.error(error)
        this.validationMessage = error.message

        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: error.message,
        })
      } finally {false,
        this.$refs.progress.hide()
      }
    },

    changePassword() {
      this.validationMessage = ''
      this.validationMessage2 = ''
      this.validationMessage3 = ''

      $('.modal.modal2').modal('show')
      $('.modal.modal2 .password-old').focus()
    },
    async save() {
      try {
    
        const isValid = await this.$validator.validateAll()
        if (!isValid) {

          Toast.validationFieldsError({ toast: this.$toast })

          return
        }
        this.$refs.progress.show()

        this.typeOfProfile = []
        if (this.affiliate) this.typeOfProfile.push('affiliate')
        if (this.producer) this.typeOfProfile.push('producer')
        if (this.investor) this.typeOfProfile.push('investor')


        var d = {
          fullName: this.userData.fullName,
          phone: this.userData.phone,
          title: this.userData.title,
          image: this.newAvatarImmage,
          password: this.userData.password,
          city: this.userData.city,
          address: this.userData.address,
          state: this.userData.state,
          country: this.userData.country,
          zipcode: this.userData.zipcode,
          typeOfProfile: this.typeOfProfile.join(','),
          contact: this.userData.contact,
          companyType: this.userData.companyType,
          company: this.userData.company,
          walletAddressGREEN: this.userData.walletAddressGREEN,
          walletGREENBEP20: this.userData.walletGREENBEP20,
        }

        await Api.updateProfile(d)
        
        this.isGreen = false;

        console.log(this.userData, d)

        Toast.success({
          toast: this.$toast,
          title: 'Success!',
          message: 'Successfully',
        })

        if(this.userData.password){
          this.$router.push('/signin')
        } else {
          // this.$router.push('/dashboard')
        }
      } catch (error) {
        console.error(error)
        this.validationMessage = error.message

        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: error.message,
        })
      } finally {false,
        this.$refs.progress.hide()
      }
    },
    close() {
      $(".modal").modal('hide');
    },
    async updatePassword() {
      try {
        
        if (this.password == '' || this.passwordOld == '' || this.passwordNew == '') {
          Toast.validationFieldsError({ toast: this.$toast })
          if (this.password == '') this.validationMessage2 = 'The field is required'; else this.validationMessage2 = ''
          if (this.passwordNew == '') this.validationMessage3 = 'The field is required'; else this.validationMessage3 = ''

          return
        }

         this.validationMessage2 = ''
      this.validationMessage3 = ''
       
        this.$refs.progress.show()

        var d = {
          passwordOld: this.passwordOld,
          password: this.password,
          
        }

        var res = await Api.updatePassword(d)
        if(res.data.message) {
          this.validationMessage = res.data.message
          return
        }
        
        console.log( res)
        $('.modal.modal2').modal('hide')

        Toast.success({
          toast: this.$toast,
          title: 'Success!',
          message: 'Successfully',
        })

  
      } catch (error) {
        console.error(error)
        this.validationMessage = error.message

        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: error.message,
        })
      } finally {false,
        this.$refs.progress.hide()
      }
    },
  },
  async created() {

    try {
      var response = await Api.myProfile()
      this.userData = response.data.results.user
      if (this.userData.walletAddressGREEN) this.isGreen = false

      if (this.userData.affiliateCode && this.userData.typeOfProfile.split(',').indexOf("affiliate")>-1) {
        this.isCode = true
      }  

      $("#name").focus()
      this.typeOfProfile = this.userData.typeOfProfile.split(',') 
      if(this.typeOfProfile.indexOf("affiliate") > -1) this.affiliate = true
      if(this.typeOfProfile.indexOf("producer") > -1) this.producer = true
      if(this.typeOfProfile.indexOf("investor") > -1) this.investor = true

      this.userData.title = (this.userData.title) ? this.userData.title.split(",") :""

      console.log("123456 this.userData ")
      console.log(this.userData)
      this.$nextTick(function() {

      })
      this.countries = require('./../../../data/country.js')
    } catch (error) {
      console.error(error)
      this.validationMessage = error.message

      Toast.error({
        toast: this.$toast,
        title: 'Error',
        message: error.message,
      })
    } finally {
      this.$refs.progress.hide()
    }
  },
  mounted() {

  },
  beforeDestroy() {

  },
}



// WEBPACK FOOTER //
// ./src/components/Account/SettingsProfile/SettingsProfile.component.js